// jshint esversion: 6
let videos = document.querySelectorAll( '.js-defer-video' );

if ( videos.length ) {

    // Retrieve video resources once page has loaded
    window.addEventListener('load', function () {

        // Loop through deferred videos and request content
        for ( let i = 0; i < videos.length; i++ ) {

            let videoSources = videos[i].querySelectorAll( 'source' );

            let autoplay = videos[i].hasAttribute( 'data-deferred-autoplay' );

            // Loop through sources to set the [src] (webm and mp4)
            for ( let j = 0; j < videoSources.length; j++ ) {

                let src = videoSources[j].getAttribute( 'data-src' ) || '';

                videoSources[j].setAttribute( 'src', src );

            }

            // Load video content now that we have the source
            videos[i].load();

            // Autoplay the video once loaded - if native [autoplay] is used the
            // video will preload automatically defeating the purpose of the defer
            if ( autoplay ) {

                $(videos[i]).one('canplay', function () {
                    
                    this.play();
                    this.style.opacity = 1;

                });

            } else {

                $(videos[i]).one('canplay', function () {
                    
                    //this.play();
                    this.style.opacity = 1;

                });

            }

        }

    }, false);

}
